<template>
  <div v-once class="listing-page">
    <header class="text-center header">
      <div class="row align-center">
        <div class="section columns small-12 medium-8">
          <h1>One Million Trees by 2033</h1>
          <p class="text-big">
            {{ description }}
          </p>
          <ul v-if="treeCount" class="tree-counter inline-list">
            <li v-for="index in 7 - treeCount.toString().length" :key="index" class="disabled">
              0
            </li>
            <li v-for="(digit, index) in numberToDigits(treeCount)" :key="index">{{ digit }}</li>
          </ul>
        </div>
      </div>
    </header>

    <section class="row section align-center">
      <div class="columns">
        <ul class="row collapse block-grid small-up-1 medium-up-3 large-up-3">
          <li>
            <nuxt-img
              src="/images/one-million-trees-project/trees-1.jpg"
              alt="Growing trees"
              width="1200"
              height="800"
              loading="lazy"
              format="webp"
            />
          </li>
          <li>
            <nuxt-img
              src="/images/one-million-trees-project/trees-2.jpg"
              alt="Planting trees"
              width="1200"
              height="800"
              loading="lazy"
              format="webp"
            />
          </li>
          <li>
            <nuxt-img
              src="/images/one-million-trees-project/trees-3.jpg"
              alt="Adult trees"
              width="1200"
              height="800"
              loading="lazy"
              format="webp"
            />
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
/* Plans
 *
 * @parent:
 * @requests:
 * @events:
 * @props:
 * @components:
 * @methods:
 */

import { mapGetters } from 'vuex';

export default {
  name: 'OneMillionTrees',
  async asyncData({ store }) {
    await store.dispatch('loadSiteData');
  },
  data() {
    return {
      title: 'One Million Trees Project',
      description:
        'Teach Starter is on a mission to plant one million trees by 2033. To make this a reality, we will be planting a tree for every person who subscribes to Teach Starter.',
    };
  },
  jsonld() {
    return this.$jsonSchemaPage(this.title, this.$route.path);
  },
  head() {
    return {
      title: this.title,
      meta: [
        { hid: 'title', name: 'title', content: this.title },
        {
          hid: 'description',
          name: 'description',
          content: this.description,
        },
      ],
      link: this.$hrefLangsPage(this.$route),
    };
  },
  computed: {
    ...mapGetters(['treeCount']),
  },
  mounted() {
    this.$mzAnalyticsApi({
      event: 'pageView',
    });
  },
  methods: {
    numberToDigits(number) {
      const digits = [];
      const sNumber = number.toString();
      let i = 0;

      for (; i < sNumber.length; i++) {
        digits.push(+sNumber.charAt(i));
      }

      return digits;
    },
  },
};
</script>

<style scoped lang="scss">
.tree-counter {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  li {
    background-color: $highlighter-500;
    line-height: 1;
    margin: $base-padding-half 0.6vw;
    padding: $base-padding;
    text-align: center;
    font-size: 6vw;
    border-radius: 0.5rem;
    color: $ts-black-500;

    &.disabled {
      opacity: 0.5;
    }
  }
}
</style>
